import { render, staticRenderFns } from "./ToolsPage.vue?vue&type=template&id=5372608b&scoped=true&lang=pug&"
import script from "./ToolsPage.vue?vue&type=script&lang=ts&"
export * from "./ToolsPage.vue?vue&type=script&lang=ts&"
import style0 from "./ToolsPage.vue?vue&type=style&index=0&id=5372608b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5372608b",
  null
  
)

export default component.exports